import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { POS_TERMINALS } from '../apiUrls';

const mutationUnblacklistPosTerminal = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionId }) => {
            return client.post(replaceParameters(POS_TERMINALS.UNBLACKLIST_POS_TERMINAL.url, { subscriptionId: subscriptionId }));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUnblacklistPosTerminal;